// JsFromRoutes CacheKey e7960f59b8f683afaf944e9bf65913a7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_sections/:landing_page_section_id/landing_page_section_items/search'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/landing_page_sections/:landing_page_section_id/landing_page_section_items'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/landing_page_sections/:landing_page_section_id/landing_page_section_items'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/landing_page_section_items/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/landing_page_section_items/:id'),
}
